<div class="car-apply">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <form #careerForm="ngForm" (ngSubmit)="onSubmit(careerForm)" novalidate>
                    <div class="row">
                        <!-- if theres position -->
                        <div class="col-md-12" *ngIf="dataPosition">
                            <div class="back d-flex align-items-center mb-2">
                                <a routerLink="/career/">
                                    <svg width="51" height="14" viewBox="0 0 51 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M50 7L1 7" stroke="url(#paint0_linear)" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 13L0.999999 7L8 1" stroke="url(#paint1_linear)" stroke-linecap="round" stroke-linejoin="round"/>
                                        <defs>
                                        <linearGradient id="paint0_linear" x1="25.4998" y1="7.00556" x2="25.4998" y2="8.01736" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#354A5F"/>
                                        <stop offset="1" stop-color="#1E3750"/>
                                        </linearGradient>
                                        <linearGradient id="paint1_linear" x1="4.49997" y1="1.06667" x2="4.49997" y2="13.2083" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#354A5F"/>
                                        <stop offset="1" stop-color="#1E3750"/>
                                        </linearGradient>
                                        </defs>
                                    </svg>
                                </a>
                                <p class="ml-3 mb-0">{{ isLang?.applyFor }}</p>
                            </div>
                            <h3 class="f-subtit mb-3">{{ dataPosition?.title }}</h3>
                            <div class="location d-flex"> 
                                <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 0C3.13 0 0 3.13 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.13 10.87 0 7 0ZM7 9.5C5.62 9.5 4.5 8.38 4.5 7C4.5 5.62 5.62 4.5 7 4.5C8.38 4.5 9.5 5.62 9.5 7C9.5 8.38 8.38 9.5 7 9.5Z" fill="#333333"/>
                                </svg>
                                <p class="ml-3 mb-0">{{ dataRegional?.title }}</p>
                            </div>
                            <div class="lane-top my-3"></div>
                        </div>
                        <!-- if no position -->
                        <div class="col-md-12 mb-4" *ngIf="!dataPosition">
                            <div class="back d-flex align-items-center mb-2">
                                <a routerLink="/career/">
                                    <svg width="51" height="14" viewBox="0 0 51 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M50 7L1 7" stroke="url(#paint0_linear)" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M8 13L0.999999 7L8 1" stroke="url(#paint1_linear)" stroke-linecap="round" stroke-linejoin="round"/>
                                        <defs>
                                        <linearGradient id="paint0_linear" x1="25.4998" y1="7.00556" x2="25.4998" y2="8.01736" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#354A5F"/>
                                        <stop offset="1" stop-color="#1E3750"/>
                                        </linearGradient>
                                        <linearGradient id="paint1_linear" x1="4.49997" y1="1.06667" x2="4.49997" y2="13.2083" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#354A5F"/>
                                        <stop offset="1" stop-color="#1E3750"/>
                                        </linearGradient>
                                        </defs>
                                    </svg>
                                </a>
                                <p class="ml-3 mb-0">{{ isLang?.buttonCV }}</p>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <p class="mb-4">{{ isLang?.pleaseFill }}</p>
                        </div>
                        <div class="col-xl-10 col-lg-11  mx-auto">
                            <div class="row">
                                <!-- Fullname -->
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-2 pt-1 text-md-right">
                                            <label for="fullname" class="mb-md-0 mb-2">{{ isLang?.fullName }}</label>
                                        </div>
                                        <div class="col-md-10">
                                            <input type="text" 
                                                    class="form-control" 
                                                    id="fullname" 
                                                    required 
                                                    #fullname="ngModel"
                                                    [class.is-invalid]="fullname.invalid && fullname.touched"
                                                    name="fullname"
                                                    ngModel>
                                            <small class="text-danger" 
                                                [class.d-none]="fullname.valid || fullname.untouched">
                                                {{ isLang?.fullName }} {{ isLang?.isRequired }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <!-- Email -->
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-2 pt-1 text-md-right">
                                            <label for="email" class="mb-md-0 mb-2">Email</label>
                                        </div>
                                        <div class="col-md-10">
                                            <input type="email" 
                                                    class="form-control" 
                                                    id="email" 
                                                    required 
                                                    #email="ngModel"
                                                    [class.is-invalid]="email.invalid && email.touched"
                                                    name="email" 
                                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                                                    email
                                                    placeholder="example@domain.com"
                                                    ngModel>
                                            <small class="text-danger" 
                                                [class.d-none]="email.valid || email.untouched">
                                                Email "example@domain.com" {{ isLang?.isRequired }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <!-- Mobile No. -->
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-2 pt-1 text-md-right">
                                            <label for="phone" class="mb-md-0 mb-2">{{ isLang?.mobileNo }}</label>
                                        </div>
                                        <div class="col-md-10">
                                            <input type="text"
                                                    pattern="[0-9\/]*"
                                                    class="form-control" 
                                                    id="phone" 
                                                    placeholder="08-XXX-XXX"
                                                    required 
                                                    #phone="ngModel"
                                                    [class.is-invalid]="phone.invalid && phone.touched"
                                                    name="phone"
                                                    ngModel>
                                            <small class="text-danger" 
                                                [class.d-none]="phone.valid || phone.untouched">
                                                {{ isLang?.mobileNo }} {{ isLang?.numberRequired2 }} {{ isLang?.isRequired }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <!-- Gender -->
                                <div class="col-md-6">
                                    <div class="form-group row">
                                        <div class="col-md-4 text-md-right">
                                            <label for="gender" class="mb-md-0 mb-2">{{ isLang?.gender }}</label>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-check form-check-inline mr-4">
                                                <input class="form-check-input" 
                                                        type="radio" 
                                                        name="gender" 
                                                        id="female"
                                                        required
                                                        value="1"
                                                        #gender="ngModel" 
                                                        ngModel>
                                                <label class="form-check-label" for="female">{{ isLang?.famale }}</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" 
                                                        type="radio" 
                                                        name="gender" 
                                                        required
                                                        id="male" 
                                                        value="2"
                                                        #gender="ngModel" 
                                                        ngModel>
                                                <label class="form-check-label" for="male">{{ isLang?.male }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Date of Birth -->
                                <div class="col-md-6">
                                    <div class="form-group row">
                                        <div class="col-md-4 pt-1 text-md-right">
                                            <label for="date_birth" class="mb-md-0 mb-2">{{ isLang?.dateOfBirth }}</label>
                                        </div>
                                        <div class="col-md-8">
                                            <input type="date" 
                                                    class="form-control" 
                                                    id="date_birth" 
                                                    required 
                                                    #date_birth="ngModel"
                                                    [class.is-invalid]="date_birth.invalid && date_birth.touched"
                                                    name="date_birth" 
                                                    ngModel>
                                            <small class="text-danger" 
                                                [class.d-none]="date_birth.valid || date_birth.untouched">
                                                {{ isLang?.dateOfBirth }} {{ isLang?.isRequired }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <!-- Address -->
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-2 pt-1 text-md-right">
                                            <label for="address" class="mb-md-0 mb-2">{{ isLang?.address }}</label>
                                        </div>
                                        <div class="col-md-10">
                                            <textarea
                                                rows="6"
                                                class="form-control" 
                                                id="address" 
                                                required 
                                                #address="ngModel"
                                                [class.is-invalid]="address.invalid && address.touched"
                                                name="address"
                                                ngModel>
                                            </textarea>
                                            <small class="text-danger" 
                                                [class.d-none]="address.valid || address.untouched">
                                                {{ isLang?.address }} {{ isLang?.isRequired }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <!-- Educational -->
                                <div class="col-md-6">
                                    <div class="form-group row">
                                        <div class="col-md-4 pt-1 text-md-right">
                                            <label for="educational" class="mb-md-0 mb-2">{{ isLang?.educational }}</label>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="select select-ver3">
                                                <ng-select2
                                                    [class.is-invalid]="educational.invalid && educational.touched"
                                                    [data]="dataEducational" 
                                                    placeholder="{{ isLang?.chooseOne }}"
                                                    name="educational"
                                                    #educational="ngModel"
                                                    ngModel>
                                                </ng-select2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Photograph -->
                                <div class="col-md-12">
                                    <div class="form-group row my-4">
                                        <div class="col-md-2 d-md-block d-none pt-1 text-md-right">
                                        </div>
                                        <div class="col-md-10 text-center">
                                            <div class="box-file">
                                                <div class="drop">
                                                    <ngx-file-drop (onFileDrop)="dropped($event)" 
                                                                    [multiple]="false" 
                                                                    accept=".docx,.doc,.rtf,.pdf">
                                                        <ng-template ngx-file-drop-content-tmp 
                                                                    let-openFileSelector="openFileSelector">
                                                                    <button class="h-100 w-100" 
                                                                            type="button" 
                                                                            (click)="openFileSelector()">
                                                                            Browse Files
                                                                    </button>
                                                        </ng-template>
                                                    </ngx-file-drop>
                                                </div>
                                                <div class="warp d-flex justify-content-center align-items-center h-100">
                                                    <div>
                                                        <p class="pb-3 text">
                                                            Upload your CV or drag and drop here<br>
                                                            <span class="text-danger" *ngIf="!fileReceive">(required)</span>
                                                        </p>
                                                        <h6 class="file-name mb-1" *ngFor="let item of files; let i=index">
                                                            {{ item.relativePath }}
                                                        </h6>
                                                        <small class="text-danger dang-file">
                                                            {{ supportFile }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                            <small> 
                                                Maximum file size is 3MB, and the format must be .pdf, .doc, .docx, or .rtf
                                            </small>
                                        </div>
                                    </div>
                                </div>
    
                                <!-- Experience -->
                                <!-- <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-2 pt-1 text-md-right">
                                            <label for="company" class="com">{{ isLang?.latestExp }}</label>
                                        </div>
                                        <div class="col-md-5 my-md-0 my-3">
                                            <input type="text" 
                                                    class="form-control" 
                                                    id="company"
                                                    #company="ngModel"
                                                    name="company"
                                                    placeholder="{{ isLang?.company }}"
                                                    ngModel>
                                        </div>
                                        <div class="col-md-5">
                                            <input type="text" 
                                                    class="form-control" 
                                                    id="position"  
                                                    #position="ngModel"
                                                    name="position"
                                                    placeholder="{{ isLang?.position }}"
                                                    ngModel>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-2 pt-1 text-md-right">
                                        </div>
                                        <div class="col-md-5 col-6">
                                            <input type="text" 
                                                    class="form-control" 
                                                    id="startDate"
                                                    #startDate="ngModel"
                                                    name="startDate"
                                                    placeholder="{{ isLang?.startDate }}"
                                                    ngModel>
                                        </div>
                                        <div class="col-md-5 col-6">
                                            <input type="text" 
                                                    class="form-control" 
                                                    id="endDate"
                                                    #endDate="ngModel"
                                                    name="endDate"
                                                    placeholder="{{ isLang?.endDate }}"
                                                    ngModel>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-2 pt-1 text-md-right">
                                        </div>
                                        <div class="col-md-10">
                                            <textarea
                                                rows="6"
                                                class="form-control" 
                                                id="giveDetail"
                                                #giveDetail="ngModel"
                                                name="giveDetail"
                                                placeholder="{{ isLang?.giveDetail }}"
                                                ngModel>
                                            </textarea>
                                        </div>
                                    </div>
                                </div> -->
    
                                <div class="col-md-12">
                                    <div class="form-group row">
                                        <div class="col-md-2 pt-1 text-md-right">
                                        </div>
                                        <div class="col-md-5">
                                            <!-- recaptcha -->
                                            <div class="d-flex justify-content-md-start align-items-center justify-content-center">
                                                <div #recaptcha></div>
                                                <span *ngIf="infoCaptcha" class="text-danger h5 pl-3">
                                                    <i class="icon ion-ios-information-circle-outline"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 mt-md-4 mt-2 mb-3">
                                    <div class="text-center">
                                        <button *ngIf="!send" 
                                                class="btn red-btn" 
                                                [disabled]="careerForm.form.invalid || !fileReceive" 
                                                type="submit">
                                                {{ isLang?.submit }}
                                        </button>
                                        <button *ngIf="send" 
                                                class="btn red-btn" 
                                                type="button" 
                                                disabled>
                                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                            Loading...
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
